import React, { useState } from 'react';
import ClientSidebar from './ClientSidebar';
import Header from './Header';
import { Box } from '@mui/material';

const COLLAPSED_W = 72;
const EXPANDED_W = 240;

const Layout = ({ activeView, onNavigate, status, apiStatus, apiStatusDetail, children }) => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('waSidebarCollapsed') === 'true';
  });

  const toggleSidebar = () => {
    setCollapsed(prev => {
      const next = !prev;
      localStorage.setItem('waSidebarCollapsed', next);
      return next;
    });
  };

  const sidebarW = collapsed ? COLLAPSED_W : EXPANDED_W;

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#fff' }}>
      <Box sx={{ width: sidebarW, flexShrink: 0, transition: 'width 0.3s ease' }}>
        <ClientSidebar
          collapsed={collapsed}
          onToggle={toggleSidebar}
          activeView={activeView}
          onNavigate={onNavigate}
          status={status}
          apiStatus={apiStatus}
          apiStatusDetail={apiStatusDetail}
        />
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Box sx={{ height: 64, flexShrink: 0 }}>
          <Header collapsed={collapsed} onNavigate={onNavigate} />
        </Box>

        <Box sx={{
          flex: 1, overflowY: 'auto', background: '#f8faff',
          position: 'relative',
        }}>
          <Box className="water-bg" sx={{ minHeight: '100%', p: '10px' }}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
